export default [
  {value: 'huadong1', label: '华东1'},
  {value: 'huadong2', label: '华东2'},
]
